<template>
  <div class="flex items-center gap-2 py-1">
    <button
      type="button"
      class="text-sm bg-transparent border-none p-0 cursor-pointer"
      :class="props.value ? props.textColor : '!text-base-color'"
      @click="setValue(false)">
      {{ props.falseLabel }}
    </button>
    <button
      type="button"
      class="relative w-8 h-2 bg-[#BCBEC0] rounded-full transition-colors shadow-md focus:outline-none"
      @click="toggleValue">
      <span
        class="absolute top-1/2 -translate-y-1/2 left-0 w-4 h-4 bg-base-color rounded-full shadow-md tr-all"
        :class="{ 'left-full -translate-x-full': props.value }"></span>
    </button>
    <button
      type="button"
      class="text-sm bg-transparent border-none p-0 cursor-pointer"
      :class="props.value ? '!text-base-color' : props.textColor"
      @click="setValue(true)">
      {{ props.trueLabel }}
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  value: { type: Boolean, required: true },
  falseLabel: { type: String, required: true },
  trueLabel: { type: String, required: true },
  textColor: { type: String, required: false, default: 'text-gray' },
});

const emit = defineEmits(['update:value']);

const setValue = (value: boolean) => {
  emit('update:value', value);
};

const toggleValue = () => {
  setValue(!props.value);
};
</script>
